import ShopPremiumFoldersContainer from './ShopPremiumFolders.container';
import ShopPremiumFolders from './ShopPremiumFolders';

export default ShopPremiumFoldersContainer(ShopPremiumFolders);
